import { z } from 'zod';

export const abMetricSchema = z.enum(['open', 'click', 'conversion']);

export const abVariantSchema = z.object({
  id: z.string().min(1).max(16),
  weight: z.number().int().min(0).max(100),
  versionId: z.string().uuid().optional(),
  subjectLine: z.string().max(200).optional(),
  label: z.string().max(40).optional(),
});

export const abExperimentStatusSchema = z.enum(['draft', 'running', 'finished', 'cancelled']);

export const createExperimentSchema = z.object({
  templateId: z.string().uuid(),
  name: z.string().min(1).max(120),
  hypothesis: z.string().max(500).optional(),
  metric: abMetricSchema.default('open'),
  variants: z.array(abVariantSchema).min(2).max(4),
  sampleSizeTarget: z.number().int().min(50).max(1_000_000).default(1000),
  winnerAuto: z.boolean().default(true),
});

export const experimentSummarySchema = z.object({
  id: z.string().uuid(),
  templateId: z.string().uuid(),
  name: z.string(),
  metric: abMetricSchema,
  status: abExperimentStatusSchema,
  sampleSizeTarget: z.number().int(),
  winnerVariantId: z.string().nullable(),
  startedAt: z.string().datetime().nullable(),
  endedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});

export type AbMetric = z.infer<typeof abMetricSchema>;
export type AbVariant = z.infer<typeof abVariantSchema>;
export type AbExperimentStatus = z.infer<typeof abExperimentStatusSchema>;
export type CreateExperimentInput = z.infer<typeof createExperimentSchema>;
export type ExperimentSummary = z.infer<typeof experimentSummarySchema>;
